import TagManager from "react-gtm-module";

export const initGTM = () => {
	const tagManagerArgs = {
		gtmId: "GTM-TKCMCHB",
	};
	TagManager.initialize(tagManagerArgs);
};
